import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useFlags } from 'wsm-common-data';
import MyCars from './MyCars';
import CompareCheckbox from './CompareCheckbox';
import DetailsButton from './DetailsButton';
import { enableModernMyCarsFlag } from '../../../global-constants';

const Footer = ({
	shouldShowCompare,
	isMyCarsSitePropEnabled,
	vehicle,
	containsVehicle,
	selected,
	setSelected,
	compareVehicles
}) => {
	const flags = useFlags();
	const enableModernMyCars = flags[enableModernMyCarsFlag];
	const { uuid, link } = vehicle;
	const { useSimplifiedListing } = useSelector((state) => state.layout);

	const shouldRenderDivider = useMemo(
		() => !enableModernMyCars && useSimplifiedListing,
		[useSimplifiedListing, enableModernMyCars]
	);

	return (
		<>
			{shouldRenderDivider && <hr className="w-100 my-3" />}
			{shouldShowCompare && (
				<CompareCheckbox
					uuid={uuid}
					containsVehicle={containsVehicle}
					selected={selected}
					setSelected={setSelected}
					compareVehicles={compareVehicles}
				/>
			)}
			{isMyCarsSitePropEnabled && <MyCars vehicle={vehicle} />}
			<DetailsButton uuid={uuid} link={link} />
		</>
	);
};

Footer.propTypes = {
	shouldShowCompare: PropTypes.bool.isRequired,
	isMyCarsSitePropEnabled: PropTypes.bool.isRequired,
	vehicle: PropTypes.shape({
		uuid: PropTypes.string,
		link: PropTypes.string
	}).isRequired,
	containsVehicle: PropTypes.func.isRequired,
	selected: PropTypes.bool.isRequired,
	setSelected: PropTypes.func.isRequired,
	compareVehicles: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Footer;
